import api from "../../config/http-common";

export const addProduct = (payload) => {
  return api.securedAxios().post("/web/api/v4/accessory", payload);
};

export const getAllProducts = (payload) => {
  return api.securedAxios().get("/web/api/v4/accessories");
};

export const updateProduct = (payload) => {
  return api
    .securedAxios()
    .put("/web/api/v4/accessories/" + payload.get("id"), payload);
};

export const getAssignedProducts = (id) => {
  return api.securedAxios().get("/web/api/v4/accessories/" + id);
};

export const purchasedProducts = (id) => {
  return api.securedAxios().get("/web/api/v4/accessories/company/" + id);
};

const ProductService = {
  addProduct,
  getAllProducts,
  updateProduct,
  getAssignedProducts,
  purchasedProducts,
};

export default ProductService;
